// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5443":"ad7f724d","6350":"72a30a16"}[chunkId] || chunkId) + "." + {"1896":"24ce3ef793e8176a","5443":"06180f8f6525f647","6350":"7f5244ae14bacb9d","7482":"452d23aa42579965","9474":"8e5b64d7277b7740"}[chunkId] + ".js";
};